module.exports = __webpack_public_path__ + "assets/word_docking_default.63fbe63c.svg";